import styled, { css } from 'styled-components'
import { animated } from '@react-spring/web'
import PropTypes from 'prop-types'
import { transparentize } from 'polished'

export const Container = styled(animated.div)`
  color: ${props => props.theme.white};

  width: 100%;
  position: relative;
  border-radius: .5rem;
  padding: 1rem;
  display: flex;
  margin-bottom: 1rem;

  ${props => MessageTypeVariations[props.type || 'info']}

    &::before {
      position: absolute;
      border-style: solid;
      border-width: .75rem .75rem 0 .75rem;
      top: 100%;
      right: 1rem;
      content: '';
    }

  .message {
    &__icon {
      margin-right: .75rem;
    }

    &__content {
      flex: 1;
      display: flex;
      justify-content: center;
      flex-direction: column;

      h4 {
        color: inherit;
      }

      p {
        margin-top: .25rem;
        font-size: .85rem;
      }
    }

    &__close {
      display: flex;
      align-items: center;
      position: absolute;
      right: .5rem;
      top: .5rem;
      opacity: .6;
      border: 0;
      background: transparent;
      color: inherit;

      ${props => !props.$hasDescription && css`
        transform: translateY(-50%);
        top: 50%;
      `}
    }

    ${props => !props.$hasDescription && css`
      display: flex;
      align-items: center;
    `}

  }
`

const MessageTypeVariations = {
  translucent: css`
    color: #000000a3;
    background: #050aff1a;

    &::before {
      border-color: #050aff1a transparent;
    }
  `,

  info: css`
    background: ${(props) => props.theme.info};

    ${(props) => css`
      box-shadow: 2px 1px 24px -8px ${transparentize(0.625, props.theme.info)};
    `};

    &::before {
      border-color: ${(props) => props.theme.info} transparent;
    }
  `,

  success: css`
    background: ${(props) => props.theme.success};

    ${(props) => css`
      box-shadow: 2px 1px 24px -8px ${transparentize(0.625, props.theme.success)};
    `};

    &::before {
      border-color: ${(props) => props.theme.success} transparent;
    }
  `,

  warning: css`
    background: ${(props) => props.theme.warning};

    ${(props) => css`
      box-shadow: 2px 1px 24px -8px ${transparentize(0.625, props.theme.warning)};
    `};

    &::before {
      border-color: ${(props) => props.theme.warning} transparent;
    }
  `,

  error: css`
    background: ${(props) => props.theme.danger};

    ${(props) => css`
      box-shadow: 2px 1px 24px -8px ${transparentize(0.625, props.theme.danger)};
    `};

    &::before {
      border-color: ${(props) => props.theme.danger} transparent;
    }
  `
}

Container.propTypes = {
  type: PropTypes.string.isRequired, // 'success' | 'error' | 'info'
  $hasDescription: PropTypes.bool
}
